import { Stack, styled } from '@mui/material';

export const FullStack = styled(Stack)(() => ({
  height: '100vh',
  width: '100%',
}));
